/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Link as ReactRouterLink } from 'react-router-dom';
import { routes } from '../app/router/routes';
import { routeWithPath } from '../util/locationChangeMiddleware';
import { getUserData } from '../user/selectors';

const Link = ({ to, external, extraClassName, className, button, secondaryButton, children, user, ...props }) => {
  if (extraClassName && className) throw new Error('extraClassName and className are mutually exclusive');

  const linkClass = classnames({
    'ncss-btn-primary-dark': button,
    'ncss-btn-secondary-dark': secondaryButton,
    link: !button && !secondaryButton && !className,
    [className]: !extraClassName,
    [extraClassName]: !!extraClassName
  });

  if (external) {
    return (
      <a href={to} className={linkClass} target='_blank' rel='noopener noreferrer'>
        {children}
      </a>
    );
  }

  const route = routeWithPath(routes, to);
  let canNavigate = true;

  // TODO: Determine why the user object is sometimes NULL
  if (route && route.limitToRoles && user && user.role) {
    canNavigate = route.limitToRoles.includes(user.role);
  }

  return canNavigate ? (
    <ReactRouterLink to={to} className={linkClass} {...props}>
      {children}
    </ReactRouterLink>
  ) : (
    children
  );
};

Link.defaultProps = {
  button: false,
  secondaryButton: false,
  external: false,
  extraClassName: '',
  className: null,
  onClick: null,
  user: null
};

Link.propTypes = {
  button: PropTypes.bool,
  secondaryButton: PropTypes.bool,
  to: PropTypes.string.isRequired,
  external: PropTypes.bool,
  extraClassName: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  user: PropTypes.shape({ role: PropTypes.string })
};

const mapStateToProps = state => ({
  user: getUserData(state)
});

export default connect(mapStateToProps, {})(Link);
